module.exports = __webpack_public_path__ + "img/jijinmanager.96c6791f.png";